import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const adminAuthGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  if (typeof window !== 'undefined') {
    const token = localStorage.getItem('adminToken');
    if (token) {
      return true;
    }
  }

  router.navigate(['/admin/login']);
  return false;
};
